import { render, staticRenderFns } from "./transferenciaEstoque.vue?vue&type=template&id=71cb0606&scoped=true&"
import script from "./transferenciaEstoque.vue?vue&type=script&lang=js&"
export * from "./transferenciaEstoque.vue?vue&type=script&lang=js&"
import style0 from "./transferenciaEstoque.vue?vue&type=style&index=0&id=71cb0606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cb0606",
  null
  
)

export default component.exports